import axios from 'axios';
import { getToken, logout } from 'data/users';
import swal from 'sweetalert';

export const PushAutomationRequest = axios.create({
    baseURL: process.env.REACT_APP_PUSH_AUTOMATION_API || 'http://localhost:6768'
});

PushAutomationRequest.interceptors.request.use(
    config => {
        const token = getToken();
        config.headers.Authorization = token ? 'Bearer ' + token : '';
        return config;
    },
    err => {
        Promise.reject(err);
    }
);

PushAutomationRequest.interceptors.response.use(
    response => response,
    error => {
        const status = error.response?.status;
        const message = error.response?.data?.error;

        if (status === 401) {
            swal('Afinidata', 'Credenciales inválidas', 'error')
            .then(() => {
                logout();
                window.location.href = '/';
            });
        } else if (status === 403) {
            swal('Afinidata', 'Usuario no tiene permisos', 'error')
            .then(() => {
                window.location.href = '/admin/dashboard';
            });
        } else if (status === 400) {
            swal('Afinidata', message || 'Datos inválidos', 'error');
        }

        return Promise.reject(error);
    }
);
